import React from "react";
import { Paper, Typography, useMediaQuery, useTheme } from "@mui/material";

export default function ManualDefinition({ title, definition }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Paper
      elevation={0}
      sx={{
        p: isMobile ? 2 : 3,
        borderRadius: 3,
        border: "1px solid var(--color-green-strong)",
        backgroundColor: "var(--color-green-soft)"
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          mb: 1,
          fontSize: isMobile ? "1rem" : "1.25rem",
        }}
      >
        {title}
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          lineHeight: 1.6,
          fontSize: isMobile ? "0.9rem" : "1rem",
        }}
      >
        {definition}
      </Typography>
    </Paper>
  );
}